module.exports = __webpack_public_path__ + "img/uk-pneumonia-female.83d8e435.png";